const languages = {
    en: require(`./en`).default,
    rf: require(`./fr`).default,
    nl: require(`./nl`).default,
};

export default languages;
